import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    ViewChild,
} from '@angular/core';
import { NgbDatepicker } from '@cmps/ng-bootstrap';

import { DateProviders } from '../../../../../common/component/datetime-picker';
import { TranslationKeyMap } from '../task/task.component.i18n';

@Component({
    selector: 'cmps-task-list-task-props',
    templateUrl: './task-props.component.html',
    providers: [DateProviders],
})
export class TaskPropsComponent implements OnDestroy {
    @Input() overdue: boolean;
    @Input() completed: boolean;
    @Input() dueDateTime: Date | null;
    @Input() important: boolean;
    @Output() dueDateTimeChange: EventEmitter<Date>;
    @Output() importanceClick: EventEmitter<void>;

    @ViewChild('dueDateTimeRef')
    readonly dueDateTimeRef: NgbDatepicker;

    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _document = document;

    constructor() {
        this.dueDateTimeChange = new EventEmitter();
        this.importanceClick = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.dueDateTimeChange.complete();
        this.importanceClick.complete();
    }
}
